import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

type Props = Readonly<{
  channelCount: number;
  allChannels: boolean;
  onChange: (allChannels: boolean) => void;
}>;

/** Scopes the transcript to the channel being played or to every channel the
 * device records; hidden when there is only one channel to read. Playback stays
 * on the selected channel either way. */
export const TranscriptScopeToggle = ({
  channelCount,
  allChannels,
  onChange,
}: Props) => {
  const { t } = useTenantTranslation();
  if (channelCount < 2) return null;

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      sx={{ alignSelf: "flex-start" }}
      value={allChannels ? "all" : "selected"}
      onChange={(_event, value) => {
        // Null when the pressed button was already selected; keep the scope.
        if (value != null) onChange(value === "all");
      }}
    >
      <ToggleButton value="selected">
        {t("radioTranscriptThisChannel")}
      </ToggleButton>
      <ToggleButton value="all">{t("radioTranscriptAllChannels")}</ToggleButton>
    </ToggleButtonGroup>
  );
};
